import React from 'react';
import '../styles/ContactUs.css';
import ContactUsComponent from '../components/ContactUsComponent';

const ContactUs = () => {
  const organizationDetails = {
    address: "#122 Optima, Puttappa Industrial Estate, White Field Road, Mahadevapura",
    city: "Bengaluru - Karnataka - 560048",
    email: "connect@infinipoint.ai",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.6064845071733!2d77.6907639!3d12.9970025!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1120cf211529%3A0xcaa22d16a21e8d10!2sInfinipoint%20Technologies%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1737709126951!5m2!1sen!2sin"
  };

  const handleGetDirections = () => {
    // window.open(`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    //   '122 OPTIMA, 55, Whitefield Main Rd, Maheswari Nagar, B Narayanapura, Mahadevapura, Bengaluru, Karnataka 560048'
    // )}`);
    window.open(`https://www.google.com/maps/dir/?api=1&destination=12.9970025,77.6907639`);
  };

  return (
    <ContactUsComponent 
    organizationDetails={organizationDetails} 
    handleGetDirections={handleGetDirections}
    />
  );
};

export default ContactUs;

